export default "__VITE_ASSET__DcM1K3VF__"